import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import AccountTxComponent from './component'


const mapDispatchToProps = (dispatch) => {
    return {...bindActionCreators({}, dispatch)};
   }

const mapStateToProps = (state) => {
    const { isAuthenticated, accessToken, error } = state.auth
    return {
        isAuthenticated,
        accessToken,
        error
    }
}
  
const AccountTxContainer= withRouter(connect(mapStateToProps, mapDispatchToProps)(AccountTxComponent));

export default AccountTxContainer;
